import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import CalloutStats from './CalloutStats';
import PieChart from './Chart/PieChart';
import Quote from './Quote';
import TwoColumnImageText from './TwoColumnImageText';
import { DWB21_Purple } from './colors';

const Wrapper = styled.div`
    max-width: 1540px;
`;

export default function Agencies() {
    return (
        <Wrapper>
            <TwoColumnImageText
                variations={['media-first']}
                backgroundColor={DWB21_Purple}
                heading="The Great Agency Exodus"
                subHeading="A desire for something different."
                mediaProps={{
                    fallbackImageUrl: publicImageUrl(
                        'design-without-borders/the-great-agency-exodus.gif'
                    ),
                    webpUrl: publicImageUrl('design-without-borders/the-great-agency-exodus.webp'),
                    mediaAlign: 'left',
                    height: { extraLarge: '130%', large: '100%', normal: '100%', medium: '100%' },
                    leftAlign: {
                        extraLarge: '-15%',
                        large: '-10%',
                        normal: '-15%',
                        medium: '-20px',
                    },
                    objectPosition: {
                        extraLarge: { xAxis: 'right', yAxis: 0 },
                        large: { xAxis: 'right', yAxis: '60px' },
                        normal: { xAxis: 'right', yAxis: 0 },
                        medium: { xAxis: 'right', yAxis: 0 },
                    },
                }}
                borderBottom={true}
                bottom={
                    <CalloutStats
                        side={<PieChart percentage={30} />}
                        stats={'30%'}
                        body={
                            '(almost a third) of freelance designers with agency experience have quit in the past twelve months'
                        }
                    />
                }
            >
                Are agencies losing their agency over freelancers? As industries are hit by the
                tidal wave of the ‘Great Resignation’, designers are reconsidering their place in
                the traditional agency landscape. 1 in 5 freelancers currently work at an agency –
                and almost half (45%) of them have considered leaving in the past year. With the
                typical high pressure associated with agency work, it may be no coincidence that
                this shift has happened in a year where 60% of freelancers have created better
                work-life balance.
            </TwoColumnImageText>
            <Box height="80px"></Box>
            <Quote
                backgroundColor={DWB21_Purple}
                text={
                    'My biggest win this year was leaving full-time agency work to freelance with my own clients.'
                }
                designerName={'Designer #4068, Australia'}
            />
        </Wrapper>
    );
}
